<template>
  <div>
    <v-tabs>
      <v-tabs v-model="tab" active-class="tab-active" background-color="transparent">
        <!-- <v-tab class="tab-default" :key="1">Khung điểm</v-tab>
        <v-tab class="tab-default" :key="2">Điều kiện thi</v-tab> -->
        <v-tab class="tab-default" :key="1">Lớp học</v-tab>
      </v-tabs>
    </v-tabs>
    <v-card outlined :flat="$vuetify.breakpoint.smAndDown">
      <v-tabs-items v-model="tab">
        <!-- <v-tab-item :key="1">
          <MarkConfig />
        </v-tab-item>
        <v-tab-item :key="2">
          <ExamConditionConfig />
        </v-tab-item> -->
        <v-tab-item :key="1">
          <ClassView />
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
import ClassView from './classView/index.vue'
import ExamConditionConfig from './examCondition/index.vue'
import MarkConfig from './markConfig/index.vue'

export default {
  components: {
    ClassView,
    ExamConditionConfig,
    MarkConfig,
  },
  data() {
    return {
      tab: null,
    }
  },
}
</script>
